export default __webpack_public_path__ + "static/media/akaunting-dashboard.4164d4f2.png";